module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/default-4af8a39e0735937d9842adde693f5fd2.svg";